module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('a', {
    attrs: {
      "href": "#/html/03_contents#intro1"
    }
  }, [_c('b', [_vm._v("INTRODUCTION TO THE ENGLISH EDITION")])])]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "intro_ind"
  }, [_vm._v("This project was made possible by the generous help of several individuals. Without their considerable effort we would not be reading this great work in the English language. Mrs. Hilda Nelson spear-headed the translation process over ten years ago and brought this manuscript to our attention along with the unique collection of Mr. Henriquet’s personal photographs of Nuno Oliveira and his horses. Some photos have not been published before and are not in the French edition. Enjoy the thousands of unwritten words represented by the fifty pictures presented. Thanks to Cavalcade, the French publisher for graciously endorsing the English edition.")]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "intro_ind"
  }, [_vm._v("A special thanks is owed to Michel Henriquet for generously sharing with us the 30 years of private correspondence and personal notes taken during his long period of study with Master Nuno Oliveira. A rare window into the insights and methods of this 20th century master is chronicled in Mr. Henriquet’s work.")]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "intro_ind"
  }, [_vm._v("We are thankful to Jessie van Eck for reviewing the translation and verifying it with Mr. Henriquet. She added the unique benefit of ensuring that Mr. Henriquet’s intent was carried through to the English reader.")]), _vm._v(" "), _c('p', {
    staticClass: "xsmallspace"
  }), _c('p', {
    staticClass: "intro_ind"
  }, [_vm._v("Finally we are so grateful to Master Nuno Oliveira whose rare talent is pictured and chronicled here. We can only benefit from his generosity of spirit in relaying his genius to Mr. Henriquet over the course of their student-mentor relationship. Nuno Oliveira’s work lives on in the work and artistry of his equestrian disciples and in the printed word. This is a testament to what was learned by one and shared with all.")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "intro_ind"
  }, [_vm._v("-Richard F. Williams, Xenophon Press")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8115c4fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_introduction.vue
// module id = 69
// module chunks = 0